 
import axios from 'axios';
import $store from "@/state/store";

import { AuthService } from "@/services/auth.service";
import { BaseAbstractService } from "@/services/base.abstract.service";

export class OtherService extends BaseAbstractService {
  static get baseUrl() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_NEXT360_URL_HOST;
  }

  static get entityApp() {
    return "n360/inte/api"
  }

  static async uploadImage(data) {
    try {
      const params = {
        fileName: `${Date.now()}`,
        folder: "nextshop"
      };
      const response = await this.callApi(false).post(
        `s3/image?fileName=${params.fileName}&folder=${params.folder}`,
        data,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  static async getlistBusiness() {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/api/business-field-list`,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getlistCity() {
    try {
      const params = {
        countryCode: "vn"
      }
      const response = await axios.post(
        `${this.URL_GATEWAY}/api/city-list`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getlistDistrict(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/api/district-list`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getlistWard(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/api/ward-list`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getTutorial() {
    try {
      const response = await this.callApi().get(
        `${this.baseUrl}/nsh/main/api/tutorials`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  } 

  static async getListAppIntegrate(key) {
    try {
      const response = await this.callApi().get(
        `${this.entityApp}/integrate/app/get-apps-with-integrate-info-by-category/${key}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async getInfoIntegrateByAppCode(key) {
    try {
      const response = await this.callApi().get(
        `${this.entityApp}/integrate-info/get-info-by-app-code/${key}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async sendSmsOtpHeyU(phoneNo) {
    try {
      const response = await this.callApi().get(
        `${this.entityApp}/delivery/heyu/send-sms-otp/${phoneNo}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async activeAccountHeyU(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityApp}/delivery/heyu/login`,param
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async unlinkAccountIntegrate(appCode) {
    try {
      const response = await this.callApi().post(
        `${this.entityApp}/integrate-info/unlink/${appCode}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
}
